import inputGhostRenderer from './input-ghost-renderer'
import suggestionTextRenderer from './suggestion-text-renderer'

export {
  inputGhostRenderer,
  suggestionTextRenderer
}

export default {
  inputGhostRenderer,
  suggestionTextRenderer
}
